export const invoicesData = [
  {
    key: "1",
    INVOICENO: "#INV12345",
    IMAGE: "avatar-20.jpg",
    NAME: "Andrew Simons",
    EMAIL: "andrew@example.com",
    CREATEDDATE: "24 Jan 2025",
    CREATEDTIME: "01:00 PM",
    DUEDATE: "24 Jan 2025",
    DUETIME: "01:00 PM",
    INVOICEAMOUNT: "$120.00",
    STATUS: "Paid",
  },
  {
    key: "2",
    INVOICENO: "#INV12346",
    IMAGE: "avatar-21.jpg",
    NAME: "David Steiger",
    EMAIL: "david@example.com",
    CREATEDDATE: "19 Dec 2024",
    CREATEDTIME: "10:00 AM",
    DUEDATE: "19 Dec 2024",
    DUETIME: "10:00 AM",
    INVOICEAMOUNT: "$85.00",
    STATUS: "Pending",
  },
  {
    key: "3",
    INVOICENO: "#INV12347",
    IMAGE: "avatar-12.jpg",
    NAME: "Virginia Phu",
    EMAIL: "phu@example.com",
    CREATEDDATE: "11 Dec 2024",
    CREATEDTIME: "08:30 AM",
    DUEDATE: "11 Dec 2024",
    DUETIME: "08:30 AM",
    INVOICEAMOUNT: "$120.00",
    STATUS: "Paid",
  },
  {
    key: "4",
    INVOICENO: "#INV12348",
    IMAGE: "avatar-22.jpg",
    NAME: "Walter Hartmann",
    EMAIL: "walter@example.com",
    CREATEDDATE: "29 Nov 2024",
    CREATEDTIME: "03:15 PM",
    DUEDATE: "29 Nov 2024",
    DUETIME: "03:15 PM",
    INVOICEAMOUNT: "$175.00",
    STATUS: "Overdue",
  },
  {
    key: "5",
    INVOICENO: "#INV12349",
    IMAGE: "avatar-08.jpg",
    NAME: "Andrea Jermaine",
    EMAIL: "jermaine@example.com",
    CREATEDDATE: "03 Nov 2024",
    CREATEDTIME: "04:10 PM",
    DUEDATE: "03 Nov 2024",
    DUETIME: "04:10 PM",
    INVOICEAMOUNT: "$200.00",
    STATUS: "Paid",
  },
  {
    key: "6",
    INVOICENO: "#INV12350",
    IMAGE: "avatar-05.jpg",
    NAME: "Dennis Eckhardt",
    EMAIL: "dennis@example.com",
    CREATEDDATE: "31 Oct 2024",
    CREATEDTIME: "11:00 AM",
    DUEDATE: "31 Oct 2024",
    DUETIME: "11:00 AM",
    INVOICEAMOUNT: "$90.00",
    STATUS: "Pending",
  },
  {
    key: "7",
    INVOICENO: "#INV12351",
    IMAGE: "avatar-25.jpg",
    NAME: "Lan Adams",
    EMAIL: "lan@example.com",
    CREATEDDATE: "15 Oct 2024",
    CREATEDTIME: "09:40 AM",
    DUEDATE: "15 Oct 2024",
    DUETIME: "09:40 AM",
    INVOICEAMOUNT: "$160.00",
    STATUS: "Paid",
  },
  {
    key: "8",
    INVOICENO: "#INV12352",
    IMAGE: "avatar-17.jpg",
    NAME: "Ann Crump",
    EMAIL: "crump@example.com",
    CREATEDDATE: "26 Sep 2024",
    CREATEDTIME: "02:30 PM",
    DUEDATE: "26 Sep 2024",
    DUETIME: "02:30 PM",
    INVOICEAMOUNT: "$180.00",
    STATUS: "Unpaid",
  },
  {
    key: "9",
    INVOICENO: "#INV12353",
    IMAGE: "avatar-07.jpg",
    NAME: "Julie Black",
    EMAIL: "julie@example.com",
    CREATEDDATE: "01 Sep 2024",
    CREATEDTIME: "05:20 PM",
    DUEDATE: "01 Sep 2024",
    DUETIME: "05:20 PM",
    INVOICEAMOUNT: "$230.00",
    STATUS: "Paid",
  },
  {
    key: "10",
    INVOICENO: "#INV12354",
    IMAGE: "avatar-26.jpg",
    NAME: "Jean Walker",
    EMAIL: "jean@example.com",
    CREATEDDATE: "15 Aug 2024",
    CREATEDTIME: "09:30 AM",
    DUEDATE: "15 Aug 2024",
    DUETIME: "09:30 AM",
    INVOICEAMOUNT: "$300.00",
    STATUS: "Paid",
  },
];
